var _style, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0088CC;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 28,
    cy: 28,
    r: 28
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.2,18.5h15.7c0.6,0,1.1,0.1,1.7,0.4c0.7,0.3,1.1,0.8,1.3,1.2c0,0,0,0.1,0.1,0.1c0.3,0.5,0.5,1.1,0.5,1.8 c0,0.6-0.1,1.2-0.5,1.8c0,0,0,0,0,0l-9.9,17c-0.2,0.4-0.6,0.6-1.1,0.6c-0.4,0-0.8-0.2-1.1-0.6l-9.7-17c0,0,0,0,0,0 c-0.2-0.4-0.6-0.9-0.6-1.7c-0.1-0.7,0.1-1.3,0.4-1.9c0.3-0.6,0.8-1.1,1.5-1.3C19.1,18.5,19.8,18.5,20.2,18.5z M26.8,20.9h-6.6 c-0.4,0-0.6,0-0.7,0.1c-0.2,0.1-0.3,0.2-0.4,0.4C19,21.5,19,21.7,19,21.9c0,0.1,0.1,0.2,0.3,0.6c0,0,0,0,0,0l7.5,13V20.9z  M29.2,20.9v14.7l7.6-13.1c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.1-0.2-0.2-0.2c0,0-0.1-0.1-0.1-0.1 c-0.2-0.1-0.4-0.1-0.7-0.1H29.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTon);
export default __webpack_public_path__ + "static/media/ton.17e79bd22beba6fa3d08ad939a9e36b5.svg";
export { ForwardRef as ReactComponent };